import "./style.css";
import { ref as M, defineComponent as T, mergeModels as B, useModel as N, computed as E, useTemplateRef as x, createElementBlock as P, openBlock as $, withModifiers as k, normalizeClass as H, createElementVNode as y, normalizeStyle as Z, unref as R, onMounted as q, onBeforeUnmount as Q, watchEffect as _, createBlock as W, renderSlot as L, createCommentVNode as Y, withDirectives as j, mergeProps as D, vShow as A } from "vue";
function V(e, s, t) {
  if (s) {
    const o = s.clientWidth, n = s.clientHeight, l = e.left / o, i = e.top / n, f = o * t, v = n * t;
    let c = -(f - o) * l, r = -(v - n) * i;
    return c = Math.max(Math.min(c, 0), o - f), r = Math.max(Math.min(r, 0), n - v), {
      left: c,
      top: r
    };
  } else
    return console.error("element not found"), { left: 0, top: 0 };
}
function ee(e, s, t, o, n) {
  if (o) {
    const l = o.clientWidth, i = o.clientHeight, f = i - i * n, v = l - l * n, c = s.left - e.left, r = s.top - e.top;
    return {
      left: Math.max(Math.min(t.left + c, 0), v),
      top: Math.max(Math.min(t.top + r, 0), f)
    };
  } else
    return console.error("element not found"), { left: 0, top: 0 };
}
const F = (e, s) => ({
  left: -e.left * s,
  top: -e.top * s
}), oe = (e, s) => ({
  left: -e.left / s,
  top: -e.top / s
});
function G(e) {
  const { clientX: s, clientY: t } = e.changedTouches[0];
  return {
    left: s,
    top: t
  };
}
function te(e, s) {
  const { clientX: t, clientY: o } = e.changedTouches[0], n = {
    left: 0,
    top: 0
  };
  if (s) {
    const l = s.getBoundingClientRect();
    n.left = t - l.left, n.top = o - l.top;
  } else
    return console.error("element not found"), n;
  return n;
}
function I(e, s) {
  if (s) {
    const t = s.getBoundingClientRect(), o = e.clientX - t.left, n = e.clientY - t.top, l = e.clientX < t.left || e.clientX > t.right || e.clientY < t.top || e.clientY > t.bottom;
    return {
      pos: { left: o, top: n },
      isOutside: l
    };
  }
  return {
    pos: { left: 0, top: 0 },
    isOutside: !0
  };
}
function J() {
  const e = M(!1);
  return { isTransition: e, startTransition: (t = 150) => {
    e.value = !0, setTimeout(() => {
      e.value = !1;
    }, t);
  } };
}
function K(e, s, t, o = 2) {
  const n = M("IN");
  return { zoomDir: n, multiStepZoomIn: (i, f, v) => {
    let c = i;
    n.value === "IN" ? c = Math.min(i + v, o) : c = Math.max(i - v, 1), c === 1 ? n.value = "IN" : c === o && (n.value = "OUT"), e.value = c, s.value = V(f, t.value, c);
  } };
}
const ne = ["alt", "src"], le = /* @__PURE__ */ T({
  __name: "DragZoomImg",
  props: /* @__PURE__ */ B({
    src: {
      type: String,
      required: !0
    },
    alt: {
      type: String
    },
    zoomScale: {
      type: Number,
      default: 2
    },
    trigger: {
      type: String,
      default: "click"
    },
    step: {
      type: Number
    }
  }, {
    currentScale: {
      default: 1
    },
    currentScaleModifiers: {},
    zoomedImgOffset: {
      default: {
        left: 0,
        top: 0
      }
    },
    zoomedImgOffsetModifiers: {}
  }),
  emits: /* @__PURE__ */ B(["error", "load"], ["update:currentScale", "update:zoomedImgOffset"]),
  setup(e, { expose: s }) {
    const t = e, o = N(e, "currentScale"), n = N(e, "zoomedImgOffset"), l = M({ left: 0, top: 0 }), i = M({ left: 0, top: 0 }), f = M(!1), v = E(() => o.value > 1), c = x("container"), { isTransition: r, startTransition: a } = J(), { multiStepZoomIn: d, zoomDir: g } = K(
      o,
      n,
      c,
      t.zoomScale
    ), b = (u) => {
      if (t.trigger === "hover") {
        const { pos: h } = I(u, c.value);
        a(), d(o.value, h, t.step ?? t.zoomScale);
      }
    }, w = () => {
      f.value = !1, t.trigger === "hover" && S();
    }, p = (u) => {
      const h = C(u);
      l.value = h, i.value = h, v.value && (f.value = !0);
    }, m = (u) => {
      if (!f.value) return;
      const h = C(u);
      n.value = ee(
        l.value,
        h,
        n.value,
        c.value,
        o.value
      ), l.value = h;
    }, z = (u) => {
      f.value = !1;
      const h = C(u);
      if (i.value.left === h.left && i.value.top === h.top) {
        const O = X(
          v.value ? new MouseEvent("mouseup", U()) : u
        );
        a(), d(o.value, O, t.step ?? t.zoomScale);
      }
    }, S = () => {
      r.value = !0, o.value = 1, n.value = {
        left: 0,
        top: 0
      }, g.value = "IN";
    }, C = (u) => u instanceof MouseEvent ? { left: u.clientX, top: u.clientY } : G(u), X = (u) => {
      if (u instanceof MouseEvent) {
        const { pos: h } = I(u, c.value);
        return h;
      } else
        return te(u, c.value);
    }, U = () => {
      var O;
      const u = (O = c.value) == null ? void 0 : O.getBoundingClientRect(), h = o.value - 1 === 0 ? 1 : o.value - 1;
      return {
        clientX: -n.value.left / h + ((u == null ? void 0 : u.left) ?? 0),
        clientY: -n.value.top / h + ((u == null ? void 0 : u.top) ?? 0)
      };
    };
    return s({
      zoomDir: g,
      multiZoom: () => {
        const u = U();
        p(new MouseEvent("mousedown", u)), z(new MouseEvent("mouseup", u));
      }
    }), (u, h) => ($(), P("div", {
      class: H(["vz-zoomimg-img-container overflow-hidden", {
        "cursor-grab": v.value && !f.value,
        "cursor-grabbing": v.value && f.value,
        "cursor-zoom-in": !v.value
      }]),
      ref: "container",
      onMouseenter: b,
      onMousedown: p,
      onMousemove: m,
      onMouseup: z,
      onMouseleave: w,
      onTouchstart: k(p, ["prevent"]),
      onTouchmove: k(m, ["prevent"]),
      onTouchend: k(z, ["prevent"])
    }, [
      y("img", {
        class: "vz-zoomimg-img zoom-effect h-full w-full object-fill",
        draggable: "false",
        alt: e.alt,
        src: e.src,
        style: Z({
          transform: `translate(${n.value.left}px, ${n.value.top}px) scale(${o.value})`,
          transformOrigin: "0 0",
          transition: R(r) ? "transform 100ms ease-in-out" : "none"
        }),
        onError: h[0] || (h[0] = (O) => u.$emit("error")),
        onLoad: h[1] || (h[1] = (O) => u.$emit("load"))
      }, null, 44, ne)
    ], 34));
  }
}), se = ["alt", "src"], ae = /* @__PURE__ */ T({
  __name: "MoveZoomImg",
  props: /* @__PURE__ */ B({
    src: {
      type: String,
      required: !0
    },
    alt: {
      type: String
    },
    zoomScale: {
      type: Number,
      default: 2
    },
    trigger: {
      type: String,
      default: "click"
    },
    step: {
      type: Number
    },
    persist: {
      type: Boolean
    }
  }, {
    currentScale: {
      default: 1
    },
    currentScaleModifiers: {},
    zoomedImgOffset: {
      default: {
        left: 0,
        top: 0
      }
    },
    zoomedImgOffsetModifiers: {}
  }),
  emits: /* @__PURE__ */ B(["error", "load"], ["update:currentScale", "update:zoomedImgOffset"]),
  setup(e, { expose: s }) {
    const t = e, o = N(e, "currentScale"), n = N(e, "zoomedImgOffset"), l = E(() => o.value > 1), i = x("container"), { isTransition: f, startTransition: v } = J(), { zoomDir: c, multiStepZoomIn: r } = K(
      o,
      n,
      i,
      t.zoomScale
    ), a = (p) => {
      if (t.trigger === "hover") {
        const { pos: m } = I(p, i.value);
        v(), r(o.value, m, t.step ?? t.zoomScale);
      }
    }, d = () => {
      t.persist || w();
    }, g = (p) => {
      const { pos: m } = I(p, i.value);
      v(), r(o.value, m, t.step ?? t.zoomScale);
    }, b = (p) => {
      const { pos: m, isOutside: z } = I(
        p,
        i.value
      );
      !z && l.value && !f.value && (n.value = V(
        m,
        i.value,
        o.value
      ));
    }, w = () => {
      f.value = !0, o.value = 1, n.value = {
        left: 0,
        top: 0
      }, c.value = "IN";
    };
    return s({
      zoomDir: c,
      multiZoom: () => {
        var m;
        const p = (m = i.value) == null ? void 0 : m.getBoundingClientRect();
        p && g({
          clientX: p.x + p.width / 2,
          clientY: p.y + p.height / 2
        });
      }
    }), (p, m) => ($(), P("div", {
      class: "vz-zoomimg-img-container cursor-zoom-in overflow-clip border-none",
      ref: "container",
      style: Z({ cursor: R(c) === "OUT" ? "zoom-out" : "zoom-in" }),
      onMouseenter: a,
      onMouseleave: d,
      onMousemove: b,
      onClick: g
    }, [
      y("img", {
        class: "vz-zoomimg-img h-full w-full object-fill",
        alt: e.alt,
        src: e.src,
        style: Z({
          transform: `translate(${n.value.left}px, ${n.value.top}px) scale(${o.value})`,
          transformOrigin: "0 0",
          transition: R(f) ? "transform 100ms ease-in-out" : "none"
        }),
        onError: m[0] || (m[0] = (z) => p.$emit("error")),
        onLoad: m[1] || (m[1] = (z) => p.$emit("load"))
      }, null, 44, se)
    ], 36));
  }
}), re = { class: "vz-zoom-btns-container absolute bottom-1 end-1 z-10 flex gap-2 p-3" }, ue = ["disabled"], ie = ["disabled"], ce = /* @__PURE__ */ T({
  __name: "ZoomButtons",
  props: {
    maxZoom: {
      type: Boolean,
      required: !0
    },
    minZoom: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["zoomIn", "zoomOut"],
  setup(e) {
    return (s, t) => ($(), P("div", re, [
      y("button", {
        class: "controls-btn zoom-out-btn",
        disabled: e.minZoom,
        onClick: t[0] || (t[0] = (o) => s.$emit("zoomOut"))
      }, null, 8, ue),
      y("button", {
        class: "controls-btn zoom-in-btn",
        disabled: e.maxZoom,
        onClick: t[1] || (t[1] = (o) => s.$emit("zoomIn"))
      }, null, 8, ie)
    ]));
  }
}), me = (e, s) => {
  const t = e.__vccOpts || e;
  for (const [o, n] of s)
    t[o] = n;
  return t;
}, fe = /* @__PURE__ */ me(ce, [["__scopeId", "data-v-2c73679c"]]), ve = ["alt", "src"], de = /* @__PURE__ */ T({
  __name: "ZoomMap",
  props: /* @__PURE__ */ B({
    src: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      default: "zoomed-img"
    },
    zoomScale: {
      type: Number,
      default: 2
    }
  }, {
    position: {
      type: Object
    },
    positionModifiers: {}
  }),
  emits: ["update:position"],
  setup(e) {
    const s = N(e, "position"), t = M(!1), o = x("backdrop"), n = x("movableWindow"), l = M(0), i = M(0), f = (d) => {
      if (o.value) {
        const { pos: g } = I(d, o.value);
        l.value = g.left, i.value = g.top;
      }
    };
    q(() => {
      o.value && o.value.addEventListener("mousemove", f);
    }), Q(() => {
      o.value && o.value.removeEventListener("mousemove", f);
    }), _(() => {
      t.value && v();
    });
    const v = () => {
      s.value = a();
    }, c = () => {
      t.value = !0;
    }, r = () => {
      t.value = !1;
    }, a = () => {
      var d, g, b, w, p, m;
      if (o.value && n.value) {
        const z = ((d = o.value) == null ? void 0 : d.clientHeight) - ((g = n.value) == null ? void 0 : g.clientHeight), S = ((b = o.value) == null ? void 0 : b.clientWidth) - ((w = n.value) == null ? void 0 : w.clientWidth), C = Math.min(
          Math.max(
            i.value - Number((p = n.value) == null ? void 0 : p.clientHeight) / 2,
            0
          ),
          z
        ), X = Math.min(
          Math.max(
            l.value - Number((m = n.value) == null ? void 0 : m.clientWidth) / 2,
            0
          ),
          S
        );
        return { top: C, left: X };
      } else
        console.error("couldn't get movable window new position");
    };
    return (d, g) => {
      var b, w;
      return $(), P("div", {
        class: "vz-map-container relative select-none overflow-clip",
        ref: "backdrop",
        onClick: v,
        onMouseleave: r
      }, [
        y("img", {
          class: "vz-map-img h-full w-full object-fill",
          ref: "imgRef",
          alt: e.alt,
          src: e.src
        }, null, 8, ve),
        y("div", {
          class: H(["vz-map-window absolute bg-white/20 hover:cursor-pointer active:cursor-move", { "invisible -z-10": !s.value }]),
          ref: "movableWindow",
          style: Z({
            left: `${(b = s.value) == null ? void 0 : b.left}px`,
            top: `${(w = s.value) == null ? void 0 : w.top}px`,
            width: `${1 / e.zoomScale * 100}%`,
            height: `${1 / e.zoomScale * 100}%`
          }),
          onMousedown: c,
          onMouseup: r
        }, null, 38)
      ], 544);
    };
  }
}), pe = { class: "vz-zoomimg-container twp relative" }, ge = /* @__PURE__ */ T({
  __name: "ZoomImg",
  props: {
    src: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      default: "zoomed-img"
    },
    zoomScale: {
      type: Number,
      default: 2
    },
    trigger: {
      type: String,
      default: "click"
    },
    zoomType: {
      type: String,
      default: "move"
    },
    step: {
      type: Number
    },
    persist: {
      type: Boolean
    },
    showZoomBtns: {
      type: Boolean
    },
    showImgMap: {
      type: Boolean
    }
  },
  emits: ["error", "load"],
  setup(e, { emit: s }) {
    const t = s, o = e, n = M(1), l = M({ left: 0, top: 0 }), i = M(1080), f = M(!0), v = M(!1), c = E(
      () => o.zoomType === "drag" || i.value < 768
    ), r = E(() => {
      if (n.value !== 1)
        return oe(l.value, n.value * 4);
    }), a = x("zoomComponent"), d = () => {
      a.value && (a.value.zoomDir = "IN", a.value.multiZoom());
    }, g = () => {
      a.value && (a.value.zoomDir = "OUT", a.value.multiZoom());
    }, b = (m) => {
      m && (l.value = F(m, n.value * 4));
    }, w = () => {
      f.value = !1, t("load");
    }, p = () => {
      v.value = !0, f.value = !1, t("error");
    };
    return q(() => {
      i.value = (window == null ? void 0 : window.innerWidth) ?? 1080;
    }), (m, z) => ($(), P("div", pe, [
      c.value ? ($(), W(le, D({
        key: 0,
        "current-scale": n.value,
        "onUpdate:currentScale": z[0] || (z[0] = (S) => n.value = S),
        "zoomed-img-offset": l.value,
        "onUpdate:zoomedImgOffset": z[1] || (z[1] = (S) => l.value = S)
      }, o, {
        ref: "zoomComponent",
        class: ["h-full w-full", {
          hidden: f.value && m.$slots.loading || v.value && m.$slots.error
        }],
        alt: e.alt,
        onError: p,
        onLoad: w
      }), null, 16, ["current-scale", "zoomed-img-offset", "class", "alt"])) : ($(), W(ae, D({
        key: 1,
        "current-scale": n.value,
        "onUpdate:currentScale": z[2] || (z[2] = (S) => n.value = S),
        "zoomed-img-offset": l.value,
        "onUpdate:zoomedImgOffset": z[3] || (z[3] = (S) => l.value = S)
      }, o, {
        ref: "zoomComponent",
        class: ["h-full w-full", {
          hidden: f.value && m.$slots.loading || v.value && m.$slots.error
        }],
        alt: e.alt,
        onError: p,
        onLoad: w
      }), null, 16, ["current-scale", "zoomed-img-offset", "class", "alt"])),
      f.value ? L(m.$slots, "loading", { key: 2 }) : Y("", !0),
      v.value ? L(m.$slots, "error", { key: 3 }) : Y("", !0),
      e.showZoomBtns ? ($(), W(fe, D({
        key: 4,
        "zoomed-img-offset": l.value,
        "onUpdate:zoomedImgOffset": z[4] || (z[4] = (S) => l.value = S),
        "current-scale": n.value,
        "onUpdate:currentScale": z[5] || (z[5] = (S) => n.value = S)
      }, o, {
        "max-zoom": n.value === e.zoomScale,
        "min-zoom": n.value === 1,
        onZoomIn: d,
        onZoomOut: g
      }), null, 16, ["zoomed-img-offset", "current-scale", "max-zoom", "min-zoom"])) : Y("", !0),
      e.showImgMap ? j(($(), W(de, {
        key: 5,
        class: "absolute bottom-[28%] left-0 box-content h-[25%] w-[25%] border-8 border-transparent outline outline-2 outline-offset-[-8px] outline-white",
        src: e.src,
        "zoom-scale": n.value,
        position: r.value,
        "onUpdate:position": b
      }, null, 8, ["src", "zoom-scale", "position"])), [
        [A, r.value]
      ]) : Y("", !0)
    ]));
  }
}), ze = ["alt", "src"], he = ["src"], Me = /* @__PURE__ */ T({
  __name: "Magnifier",
  props: {
    src: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      default: "zoomed-img"
    },
    zoomScale: {
      type: Number,
      default: 2
    },
    size: {
      type: Number,
      default: 200
    }
  },
  emits: ["error", "load"],
  setup(e) {
    const s = e, t = x("container"), o = M({ left: 0, top: 0 }), n = M(!0), l = M(s.size), i = E(() => {
      const r = {
        left: o.value.left + l.value / 2,
        top: o.value.top + l.value / 2
      }, a = F(r, s.zoomScale);
      return {
        left: a.left + l.value / 2,
        top: a.top + l.value / 2
      };
    }), f = (r) => {
      var d;
      if (t.value) {
        const { pos: g, isOutside: b } = I(
          r,
          t.value
        );
        n.value = b, n.value || (o.value = {
          left: g.left - l.value / 2,
          top: g.top - l.value / 2
        });
      }
      const a = (d = t.value) == null ? void 0 : d.getBoundingClientRect();
      o.value = {
        left: r.clientX - (a == null ? void 0 : a.left) - l.value / 2,
        top: r.clientY - (a == null ? void 0 : a.top) - l.value / 2
      };
    }, v = (r) => {
      var a, d;
      r.deltaY > 0 ? l.value = Math.max(
        (((a = t.value) == null ? void 0 : a.clientWidth) ?? 1) / 12,
        l.value - 10
      ) : l.value = Math.min(
        (((d = t.value) == null ? void 0 : d.clientWidth) ?? 1) / 1.5,
        l.value + 10
      );
    }, c = (r) => {
      var g;
      const a = (g = t.value) == null ? void 0 : g.getBoundingClientRect(), d = G(r);
      o.value = {
        left: d.left - a.left - l.value / 2,
        top: d.top - a.top - l.value / 2
      };
    };
    return (r, a) => {
      var d, g;
      return $(), P("div", {
        class: "twp vz-magnifier-img-container relative",
        ref: "container",
        onMousemove: f,
        onWheel: k(v, ["prevent"]),
        onTouchmove: k(c, ["prevent"])
      }, [
        y("img", {
          class: "vz-magnifier-img h-full w-full object-fill",
          alt: e.alt,
          src: e.src,
          onError: a[0] || (a[0] = (b) => r.$emit("error")),
          onLoad: a[1] || (a[1] = (b) => r.$emit("load"))
        }, null, 40, ze),
        j(y("div", {
          class: "vz-magnifier-lens absolute z-10 overflow-clip rounded-full shadow-inner-lg hover:cursor-none",
          style: Z({
            left: `${o.value.left}px`,
            top: `${o.value.top}px`,
            width: `${l.value}px`,
            height: `${l.value}px`
          })
        }, [
          y("img", {
            class: "vz-magnifier-lens-img h-full w-full object-fill",
            alt: "lens-zoomed-image",
            src: e.src,
            style: Z({
              transform: `translate(${i.value.left}px, ${i.value.top}px) scaleX(${e.zoomScale * (((d = R(t)) == null ? void 0 : d.clientWidth) ?? 1) / l.value}) scaleY(${e.zoomScale * (((g = R(t)) == null ? void 0 : g.clientHeight) ?? 1) / l.value})`,
              transformOrigin: "0 0"
            })
          }, null, 12, he)
        ], 4), [
          [A, !n.value]
        ])
      ], 544);
    };
  }
}), Se = {
  install: (e) => {
    e.component("ZoomImg", ge), e.component("Magnifier", Me);
  }
};
export {
  Me as Magnifier,
  ge as ZoomImg,
  Se as default
};
